/**
 * SortArrowsIcon Component
 * 
 * Double arrow icon for sortable table columns.
 * Shows up/down arrows with active state highlighting.
 */

interface SortArrowsIconProps {
  activeDirection?: 'asc' | 'desc' | null;
  className?: string;
}

const GREY = "#9A9691";
const GREY_LIGHT = "#E0DCD7";

export function SortArrowsIcon({ activeDirection, className = '' }: SortArrowsIconProps) {
  const upColor = activeDirection === 'asc' ? GREY : GREY_LIGHT;
  const downColor = activeDirection === 'desc' ? GREY : GREY_LIGHT;

  return (
    <svg 
      className={className}
      width="9" 
      height="14" 
      viewBox="0 0 9 14" 
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Up arrow */}
      <path
        d="M4.44629 0.351563L8.49331 4.35414C8.69699 4.55558 8.69129 4.88629 8.48079 5.0806C8.28437 5.26191 7.98038 5.25769 7.78906 5.071L4.44629 1.80901L1.10352 5.071C0.912203 5.25769 0.608209 5.26191 0.411789 5.0806C0.20129 4.88629 0.195593 4.55558 0.399273 4.35414L4.44629 0.351563Z"
        fill={upColor}
        stroke={upColor}
        strokeWidth="0.5"
      />
      {/* Down arrow */}
      <path
        d="M4.44629 13.457L0.399271 9.45445C0.195591 9.25301 0.201288 8.9223 0.411787 8.728C0.608207 8.54668 0.912201 8.5509 1.10352 8.73759L4.44629 11.9996L7.78906 8.73759C7.98038 8.5509 8.28437 8.54668 8.48079 8.728C8.69129 8.92231 8.69699 9.25301 8.49331 9.45445L4.44629 13.457Z"
        fill={downColor}
        stroke={downColor}
        strokeWidth="0.5"
      />
    </svg>
  );
}

